// extracted by mini-css-extract-plugin
export default {"logoSection":"RefundPolicy_logoSection__vSVfP","logo":"RefundPolicy_logo__AnqAz"};